import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AlertOutlinedSvg from "@ant-design/icons-svg/es/asn/AlertOutlined";
import AntdIcon from "../components/AntdIcon";
var AlertOutlined = function AlertOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlertOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AlertOutlined.displayName = 'AlertOutlined';
}
export default /*#__PURE__*/React.forwardRef(AlertOutlined);